import { render, staticRenderFns } from "./PopupEditStockCategory.vue?vue&type=template&id=65c823fc&scoped=true&"
import script from "./PopupEditStockCategory.vue?vue&type=script&lang=js&"
export * from "./PopupEditStockCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c823fc",
  null
  
)

export default component.exports